import * as React from 'react';
import { ModalFullscreen } from '@cian/ui-kit/modal';

import { modalFullscreen } from '../../constants/gallery';
import * as style from './FullscreenPopup.css';

export interface IFullscreenPopupyProps {
  isOpened: boolean;
  header: React.ReactNode;
  content: React.ReactNode;
  onClose(): void;
}

export function FullscreenPopup({ isOpened, header, content, onClose }: IFullscreenPopupyProps) {
  return (
    <ModalFullscreen open={isOpened} escape onClose={onClose} theme="white">
      <div id={modalFullscreen} className={style['container']}>
        {content}
      </div>
      {header}
    </ModalFullscreen>
  );
}
